module.exports = __webpack_public_path__ + "static/media/film_strip.6e344587.png";